import clsx from 'clsx'
import { ReactNode } from 'react'

import { Icon } from '@/shared/ui/icon'

import cl from './chip.module.scss'

interface ChipProps {
	className?: string
	label: string | ReactNode | JSX.Element
	onClick?: () => void
	onDelete?: () => void
	isSelected?: boolean
	isDisabled?: boolean
	theme?: `accent` | 'light' | 'outlined'
}

export const Chip = (props: ChipProps) => {
	const { className, label, isSelected, isDisabled, onClick, onDelete, theme = 'light' } = props

	const rootClassess = clsx(cl.root, cl[theme], className, {
		[cl[`${theme}__selected`]]: isSelected,
		[cl[`${theme}__disabled`]]: isDisabled
	})

	return (
		<div className={rootClassess} onClick={onDelete || onClick}>
			{label}
			{onDelete && <Icon className={cl.closeIcon} name="Close" size={16} onClick={onDelete} />}
		</div>
	)
}
